<ion-header>
    <ion-toolbar>
        <ion-buttons slot="end">
            <ion-button
                class="icon-button-accessible-background-contrast"
                [attr.aria-label]="'ARIA_LABEL_CLOSE' | translate"
                (click)="dismiss()">
                <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>

    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
    <h4 role="none" [innerHTML]="'ADD_LOOP_HELP_WHAT_IF' | translate"></h4>
    <h6 role="none" [innerHTML]="'ADD_LOOP_HELP_TWO_TRIPS' | translate"></h6>
</ion-content>
